import { render } from "./CreatePostView.vue?vue&type=template&id=526c546f&scoped=true"
import script from "./CreatePostView.vue?vue&type=script&lang=js"
export * from "./CreatePostView.vue?vue&type=script&lang=js"

import "./CreatePostView.vue?vue&type=style&index=0&id=526c546f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526c546f"]])

export default __exports__